<template lang="pug">
  TransitionExpand
    .error(v-if="visible", :key="'test'")
      small {{text}}
</template>


<script>
import TransitionExpand from '@/transitions/Expand';
export default {
  name: 'SelectionError',
  props: ['text', 'visible'],
  components: {
    TransitionExpand,
  },
}
</script>

<style lang="scss" scoped>
.error {
  background: darken($red, 10%);
  text-indent: 0;
  small {
    display: block;
    text-indent: 0;
    padding: 0.25rem 0.5rem;
    line-height: 1.15;
    color: $white;
    font-style: italic;
  }
}
</style>